"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENT_USER = void 0;
exports.CURRENT_USER = {
    id: "'115540927'",
    name: "'support e2e'",
    displayName: "'support e2e'",
    email: "'sbu-eng-application+e2euser@sumologic.com'",
    username: "'sbu-eng-application+e2euser@sumologic.com'",
    preferredTimezone: "'browser'",
};
